import { Link, useNavigate } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import React, { useEffect } from "react";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { useAuth } from "../../../Context/AuthContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { isAlphaNumeric, IsNumberKey } from "../../../Layout/Common/common";
import { SlideDown } from "../../../Layout/Common/SlideDown";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import $ from "jquery";
import { CancelButton } from "../../../Layout/Common/cancelButton";
import { PAGES } from "../../../routeConfig";
export const WebsiteSettings = () => {
  const { showNoteAlert, showDialogAlert } = useNoteAlert();
  const navigate = useNavigate();
  const [chkcheckoutoptions, setchkcheckoutoptions] = React.useState(false);
  const [ChkDuporder, setChkDuporder] = React.useState(false);
  const [showPreviousOrderPopup, setShowPreviousOrderPopup] = React.useState(true);

  const [showPoStart, setshowPoStart] = React.useState(false);
  const [showPoChrLength, setshowPoChrLength] = React.useState(false);
  const [showPoPayment, setshowPoPayment] = React.useState(false);
  const [showPoNumber, setshowPoNumber] = React.useState(false);
  const [showPoErrorMsg, setshowPoErrorMsg] = React.useState(false);
  const [showPoLink, setshowPoLink] = React.useState(false);
  const [poLink, setpoLink] = React.useState(false);
  const [poStartNumber, setpoStartNumber] = React.useState("");
  const [poLength, setpoLength] = React.useState("");
  const [poErrorMsg, setpoErrorMsg] = React.useState("");
  const [poPayment, setpoPayment] = React.useState("ALL");

  const [paymentText, setpaymentText] = React.useState("On Account");

  const [showUpdate, setshowUpdate] = React.useState(false);
  const [poNumberonlyDisable, setpoNumberonlyDisable] = React.useState(false);
  const [disableshowPoPayment, setdisableshowPoPayment] = React.useState(false);
  const { checkOrderNoMandatory, get_po_number_rules } = useGlobalFunction();
  const { userId, companyId, role, setUser } = useAuth();
  const histroy = useNavigate();
  const isAdmin = role == "1";
  useEffect(() => {
    if (showUpdate) {
      window.scrollTo(0, 0);
    }
    var data = {
      UserID: userId,
      CompanyID: companyId,
      userRole: role,
    };
    axiosInstance
      .post("websiteSetting/webSiteSetting_Load", data)
      .then((response) => {
        if (response.data != "") {
          let res = response.data;
          if (!isAdmin) {
            setShowPreviousOrderPopup(res.showPreviousOrderPopup !== false);
            return;
          }
          setchkcheckoutoptions(res.chkcheckoutoptions);
          setChkDuporder(res.chkDuporder);
          setShowPreviousOrderPopup(res.showPreviousOrderPopup !== false);
          setshowPoLink(res.showPoLink);
          setshowPoStart(res.showPoStart);
          setshowPoChrLength(res.showPoChrLengtht);
          setshowPoNumber(res.showPoNumber);
          setshowPoErrorMsg(res.showPoErrorMsg);
          setpoLink(res.poLink);
          setpaymentText(res.paymentText);
          setpoStartNumber(res.poStartNumber);
          setpoLength(res.poLength);
          setpoErrorMsg(res.poErrorMsg);
          setpoPayment(res.poPayment == null ? "ALL" : res.poPayment);
          setshowPoPayment(res.showPoPayment);
          if (res.showPoPayment == true) setdisableshowPoPayment(true);

          const isNumber_Only = (val) => /^\d*$/.test(val);

          if (isNumber_Only(res.poStartNumber)) {
            // allows only numbers (and empty string)
            setpoNumberonlyDisable(false);
          } else {
            setpoNumberonlyDisable(true);
            setshowPoNumber(false);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }, [showUpdate]);
  const inputRefs = {
    poStartNumber: React.useRef(null),
    poLength: React.useRef(null),
    poErrorMsg: React.useRef(null),
    poPayment: React.useRef(null),
  };
  const handleNavigation = () => {
    histroy(-1);
  };
  const textboxfocus = (id) => {
    $(id).focus();
  };
  const SubmitClick = () => {
    if (!isAdmin) {
      axiosInstance
        .post("websiteSetting/updatePreviousOrderPopup", {
          UserID: userId,
          showPreviousOrderPopup: showPreviousOrderPopup,
        })
        .then((response) => {
          if (response.data != "Success") {
            showNoteAlert(response.data);
          } else {
            setUser((prev) => (prev ? { ...prev, showPreviousOrderPopup } : prev));
            document.getElementById("divUpdateSuccess").style.display = "block";
            document.getElementById("divShowDetails").style.display = "none";
            setshowUpdate(true);
          }
        })
        .catch((error) => console.log(error.message));
      return;
    }
    var data = {
      UserID: userId,
      chkcheckoutoptions: chkcheckoutoptions,
      ChkDuporder: ChkDuporder,
      ChkDuporder: ChkDuporder,
      showPreviousOrderPopup: showPreviousOrderPopup,
      chkPO_Start: showPoStart,
      showPoChrLength: showPoChrLength,
      showPoPayment: showPoPayment,
      showPoNumber: showPoNumber,
      showPoErrorMsg: showPoErrorMsg,
      showPoLink: showPoLink,
      poLink: poLink,
      poStartNumber: poStartNumber,
      poLength: poLength,
      poErrorMsg: poErrorMsg,
      poPayment: poPayment,
    };
    if (showPoStart && poStartNumber == "") {
      showNoteAlert("Please Enter PO Must Start with", "Please Note", true, () => {
        $("#poStartNumber").focus();
      });
      return;
    }
    if (showPoChrLength && poLength == "") {
      showNoteAlert("Please Enter PO Character Length", "Please Note", true, () => {
        $("#poLength").focus();
      });
      return;
    } else {
      if (showPoChrLength && poLength != "") {
        const startValueLen = parseInt(poStartNumber.length, 10);
        const lengthValue = parseInt(poLength, 10);

        if (lengthValue <= startValueLen) {
          showNoteAlert(`Please enter PO Character Length greater than ${startValueLen}`, "Please Note", true, () => {
            $("#poLength").focus();
          });
          return;
        } else if (lengthValue > 24) {
          showNoteAlert("PO Character Length must be less than or equal to 24", "Please Note", true, () => {
            $("#poLength").focus();
          });

          return;
        }
      }
    }
    if (showPoErrorMsg && poErrorMsg == "") {
      showNoteAlert("Please Enter PO Error Message", "Please Note", true, () => {
        $("#poErrorMsg").focus();
      });
      return;
    }

    if (showPoPayment == true) {
      if (showPoStart == true || showPoChrLength == true || showPoErrorMsg == true || showPoNumber == true) {
        if (poPayment == "") {
          showNoteAlert("Please Select Payment type", "Please Note", true, () => {
            $("#poPayment").focus();
          });
        }
      }
    } else {
      if (showPoStart == true || showPoChrLength == true || showPoErrorMsg == true || showPoNumber == true) {
        setshowPoPayment(true);
        if (poPayment == "") {
          showNoteAlert("Please Select Payment type", "Please Note", true, () => {
            $("#poPayment").focus();
          });
        }
      }
    }
    axiosInstance
      .post("websiteSetting/btnUpdate_Click", data)
      .then((response) => {
        if (response.data != "") {
          if (response.data != "Success") {
            showNoteAlert(response.data);
          } else {
            checkOrderNoMandatory();
            get_po_number_rules();
            setUser((prev) => (prev ? { ...prev, showPreviousOrderPopup } : prev));
            document.getElementById("divUpdateSuccess").style.display = "block";
            document.getElementById("divShowDetails").style.display = "none";
            setshowUpdate(true);
          }
        }
      })
      .catch((error) => console.log(error.message));
  };
  const onchangeChecked = (e) => {
    const checked = e.target.checked;
    if (checked == true) {
      setshowPoPayment(true);
      setdisableshowPoPayment(true);
      setpoPayment("ALL");
    } else if (
      document.getElementById("poStart").checked == true ||
      document.getElementById("poChrLength").checked == true ||
      document.getElementById("poMsg").checked == true ||
      document.getElementById("poNumber").checked == true
    ) {
      if (showPoPayment == false) {
        setshowPoPayment(true);
        setdisableshowPoPayment(true);
        setpoPayment("ALL");
      }
    } else {
      setshowPoPayment(false);
      setdisableshowPoPayment(false);
      setpoPayment("");
    }
  };
  const checkNumberOnly = (e) => {
    const input = e.target.value;

    const isNumber_Only = (val) => /^\d*$/.test(val);

    if (isNumber_Only(input)) {
      // allows only numbers (and empty string)
      setpoNumberonlyDisable(false);
    } else {
      setpoNumberonlyDisable(true);
      setshowPoNumber(false);
    }
  };
  return (
    <>
      <BreadCrumb
        data={[
          { name: "My Account", url: PAGES.MYACCOUNT },
          { name: "Website Settings", url: PAGES.WEBSITE_SETTINGS },
        ]}
      />

      <section className="myAccount-section">
        <div className="container-fluid container-lg" id="divShowDetails" style={{ display: "block" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">Website Settings</h1>
                </div>
              </div>
            </div>
            <div className="col-md-10 col-lg-9">
              <div className="row mt-4">
                <h3 className="website-settings-title">Checkout Options</h3>
                <div className="col-lg-12">
                  <div className="row">
                    {isAdmin && (
                      <>
                        <div className="col-sm-6 col-md-6">
                          <div className="checkoutOptions mt-2">
                            <div className="checkoutOptions-info">
                              <svg
                                width="29"
                                height="30"
                                viewBox="0 0 29 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M24.7709 14.1535V9.00602C24.7709 4.13644 23.6351 2.91602 19.0676 2.91602H9.93258C5.36508 2.91602 4.22925 4.13644 4.22925 9.00602V22.6118C4.22925 25.826 5.99343 26.5873 8.13218 24.2914L8.14424 24.2793C9.13507 23.2281 10.6455 23.3127 11.5034 24.4606L12.7238 26.0918"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M9.66675 8.95898H19.3334"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M10.875 13.791H18.125"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M22.0049 18.3467L17.7274 22.6242C17.5582 22.7934 17.4011 23.1075 17.3649 23.3371L17.1353 24.9684C17.0507 25.5604 17.4616 25.9713 18.0536 25.8867L19.6849 25.6571C19.9145 25.6209 20.2407 25.4638 20.3978 25.2946L24.6753 21.0171C25.4124 20.28 25.7628 19.4221 24.6753 18.3346C23.5999 17.2592 22.742 17.6096 22.0049 18.3467Z"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M21.3865 18.9629C21.749 20.2679 22.764 21.2829 24.069 21.6454"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                              <h4>
                                Set <b>'Order No'</b> Field as Mandatory
                              </h4>
                              <div className="checkoutOptions-input" id="switchOff">
                                <input
                                  type="checkbox"
                                  id="switchOrder"
                                  checked={chkcheckoutoptions}
                                  onChange={() => setchkcheckoutoptions(!chkcheckoutoptions)}
                                />
                                <label htmlFor="switchOrder">Toggle</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                          <div className="checkoutOptions mt-2">
                            <div className="checkoutOptions-info">
                              <svg
                                width="29"
                                height="30"
                                viewBox="0 0 29 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.3334 16.0868V21.1618C19.3334 25.391 17.6417 27.0827 13.4126 27.0827H8.33758C4.10841 27.0827 2.41675 25.391 2.41675 21.1618V16.0868C2.41675 11.8577 4.10841 10.166 8.33758 10.166H13.4126C17.6417 10.166 19.3334 11.8577 19.3334 16.0868Z"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M26.5834 8.83685V13.9118C26.5834 18.141 24.8917 19.8327 20.6626 19.8327H19.3334V16.0868C19.3334 11.8577 17.6417 10.166 13.4126 10.166H9.66675V8.83685C9.66675 4.60768 11.3584 2.91602 15.5876 2.91602H20.6626C24.8917 2.91602 26.5834 4.60768 26.5834 8.83685Z"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                              <h4>Allow Duplicate Purchase Order Nos. (with warning notification)</h4>
                            </div>
                            <div className="checkoutOptions-input" id="switchOff">
                              <input
                                type="checkbox"
                                id="switchDuplicate"
                                checked={ChkDuporder}
                                onChange={(e) => setChkDuporder(!ChkDuporder)}
                              />
                              <label htmlFor="switchDuplicate">Toggle</label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-sm-6 col-md-6">
                      <div className="checkoutOptions mt-2">
                        <div className="checkoutOptions-info">
                          <svg
                            width="29"
                            height="30"
                            viewBox="0 0 29 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.41675 3.5H4.51925C5.82425 3.5 6.85133 4.62375 6.74258 5.91667L5.73966 17.9517C5.57049 19.9213 7.12925 21.6129 9.11091 21.6129H21.9796C23.7196 21.6129 25.2421 20.1871 25.375 18.4592L26.0275 9.39583C26.1725 7.39 24.6501 5.75958 22.6321 5.75958H7.03258"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M19.6355 27.0833C20.4693 27.0833 21.1453 26.4074 21.1453 25.5736C21.1453 24.7398 20.4693 24.0638 19.6355 24.0638C18.8017 24.0638 18.1257 24.7398 18.1257 25.5736C18.1257 26.4074 18.8017 27.0833 19.6355 27.0833Z"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M9.96875 27.0833C10.8026 27.0833 11.4785 26.4074 11.4785 25.5736C11.4785 24.7398 10.8026 24.0638 9.96875 24.0638C9.13492 24.0638 8.45898 24.7398 8.45898 25.5736C8.45898 26.4074 9.13492 27.0833 9.96875 27.0833Z"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M10.875 10.375H25.375"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                          <h4>Show Previous Order Popup (items left in cart from a previous session)</h4>
                        </div>
                        <div className="checkoutOptions-input" id="switchOff">
                          <input
                            type="checkbox"
                            id="switchPreviousOrder"
                            checked={showPreviousOrderPopup}
                            onChange={() => setShowPreviousOrderPopup(!showPreviousOrderPopup)}
                          />
                          <label htmlFor="switchPreviousOrder">Toggle</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                {isAdmin && (
                  <>
                    <div className="col-lg-12">
                      <h3 className="website-settings-title">Purchase Order Number Format Rules</h3>
                    </div>
                    <div className="col-lg-12">
                      <div className="purchase-format mt-3">
                        <div className="purchase-format-info">
                          <h5>PO Must Start with</h5>
                          <div className="checkoutOptions-input" id="switchOff">
                            <input
                              type="checkbox"
                              id="poStart"
                              maxLength="6"
                              checked={showPoStart}
                              onChange={(e) => {
                                setshowPoStart(!showPoStart);
                                setpoStartNumber("");
                                onchangeChecked(e);
                              }}
                            />
                            <label htmlFor="poStart">Toggle</label>
                          </div>
                        </div>
                        <SlideDown show={showPoStart}>
                          <div className="mt-3">
                            <div className="textbox-container">
                              <input
                                type="text"
                                className="form-control"
                                id="poStartNumber"
                                placeholder="Enter Max 6 Characters"
                                maxLength={6}
                                value={poStartNumber}
                                ref={inputRefs.poStartNumber}
                                onChange={(e) => {
                                  setpoStartNumber(isAlphaNumeric(e.target.value));
                                  checkNumberOnly(e);
                                }}
                              />
                            </div>
                          </div>
                        </SlideDown>
                      </div>
                      <div className="purchase-format mt-3">
                        <div className="purchase-format-info">
                          <h5>PO Character Length</h5>
                          <div className="checkoutOptions-input" id="switchOff">
                            <input
                              type="checkbox"
                              id="poChrLength"
                              checked={showPoChrLength}
                              onChange={(e) => {
                                setshowPoChrLength(!showPoChrLength);
                                setpoLength("");
                                onchangeChecked(e);
                              }}
                            />
                            <label htmlFor="poChrLength">Toggle</label>
                          </div>
                        </div>
                        <SlideDown show={showPoChrLength}>
                          <div className="mt-3">
                            <div className="textbox-container">
                              <input
                                type="text"
                                className="form-control"
                                id="poLength"
                                placeholder="Enter PO Character Length"
                                value={poLength}
                                onChange={(changeEvent) => setpoLength(IsNumberKey(changeEvent.target.value))}
                                ref={inputRefs.poLength}
                                maxLength={4}
                              />
                            </div>
                          </div>
                        </SlideDown>
                      </div>
                      <div className="purchase-format mt-3">
                        <div className="purchase-format-info">
                          <h5>PO Use numbers Only</h5>
                          <div className="checkoutOptions-input" id="switchOff">
                            <input
                              type="checkbox"
                              id="poNumber"
                              checked={showPoNumber}
                              disabled={poNumberonlyDisable}
                              onChange={(e) => {
                                setshowPoNumber(!showPoNumber);
                                onchangeChecked(e);
                              }}
                            />
                            <label htmlFor="poNumber">Toggle</label>
                          </div>
                        </div>
                      </div>
                      <div className="purchase-format mt-3">
                        <div className="purchase-format-info">
                          <h5>PO Error Message if Criteria Not met</h5>
                          <div className="checkoutOptions-input" id="switchOff">
                            <input
                              type="checkbox"
                              id="poMsg"
                              checked={showPoErrorMsg}
                              onChange={(e) => {
                                setshowPoErrorMsg(!showPoErrorMsg);
                                setpoErrorMsg("");
                                onchangeChecked(e);
                              }}
                            />
                            <label htmlFor="poMsg">Toggle</label>
                          </div>
                        </div>
                        <SlideDown show={showPoErrorMsg}>
                          <div className="mt-3">
                            <div className="textbox-container">
                              <textarea
                                className="form-control"
                                rows={6}
                                maxLength={600}
                                id="poErrorMsg"
                                value={poErrorMsg}
                                ref={inputRefs.poErrorMsg}
                                onChange={(e) => setpoErrorMsg(e.target.value)}
                              />
                            </div>
                          </div>
                        </SlideDown>
                      </div>
                      <div className="purchase-format mt-3">
                        <div className="purchase-format-info">
                          <h5>PO Format Rules apply to the following payment options</h5>
                          <div className="checkoutOptions-input inputPoFormat" id="switchOff">
                            <input
                              type="checkbox"
                              id="poPayment"
                              checked={showPoPayment}
                              onChange={() => setshowPoPayment(!showPoPayment)}
                              disabled={disableshowPoPayment}
                            />
                            <label htmlFor="poPayment">Toggle</label>
                          </div>
                        </div>
                        <SlideDown show={showPoPayment}>
                          <div
                            className="poFormat"
                            style={{
                              display: showPoPayment ? "block" : "none",
                              opacity: "1",
                            }}
                          >
                            <div className="textbox-container">
                              <div className="row">
                                {/* All Payments */}
                                <div className="col-lg-4 mt-3">
                                  <div className="poFormat-info">
                                    <div className="form-check custom-check">
                                      <div className="poFormat-info-input">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="cardSelection"
                                          id="allPoformat"
                                          value="ALL"
                                          checked={poPayment == "ALL"}
                                          onChange={(e) => setpoPayment(e.target.value)}
                                          ref={inputRefs.poPayment}
                                        />
                                      </div>
                                      <label htmlFor="allPoformat">All Payments</label>
                                    </div>
                                  </div>
                                </div>

                                {/* On Account */}
                                <div className="col-lg-4 mt-3">
                                  <div className="poFormat-info">
                                    <div className="form-check custom-check">
                                      <div className="poFormat-info-input">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="cardSelection"
                                          id="poOnAccount"
                                          value={paymentText}
                                          checked={poPayment == paymentText}
                                          onChange={(e) => setpoPayment(e.target.value)}
                                          ref={inputRefs.poPayment}
                                        />
                                      </div>
                                      <label htmlFor="poOnAccount">{paymentText}</label>
                                    </div>
                                  </div>
                                </div>

                                {/* Credit Card */}
                                <div className="col-lg-4 mt-3">
                                  <div className="poFormat-info">
                                    <div className="form-check custom-check">
                                      <div className="poFormat-info-input">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="cardSelection"
                                          id="poCredit"
                                          value="Credit Card Online"
                                          checked={poPayment == "Credit Card Online"}
                                          onChange={(e) => setpoPayment(e.target.value)}
                                          ref={inputRefs.poPayment}
                                        />
                                      </div>
                                      <label htmlFor="poCredit">Credit Card Online</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SlideDown>
                      </div>

                      {/* Linked Accounts */}
                      <div className="purchase-format mt-3" style={{ display: showPoLink ? "block" : "none" }}>
                        <div className="purchase-format-info">
                          <h5>Update all the Linked Accounts</h5>
                          <div className="checkoutOptions-input" id="switchOff">
                            <input type="checkbox" id="poLink" checked={poLink} onChange={() => setpoLink(!poLink)} />
                            <label htmlFor="poLink">Toggle</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="col-md-12 col-lg-12 mt-3">
                  <div className="accountBtns-list">
                    <div className="button-effect">
                      <a
                        className="btn btn-products theme-primary"
                        style={{ color: "white", fontWeight: "normal" }}
                        data-bs-dismiss="modal"
                        onClick={() => SubmitClick()}
                      >
                        Update
                      </a>
                    </div>
                    {/* <div className="product-button">
                      <button type="button" onClick={handleNavigation}>
                        Cancel
                      </button>
                    </div> */}
                    <CancelButton
                      onClick={() => {
                        histroy(PAGES.MYACCOUNT);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid container-lg" id="divUpdateSuccess" style={{ display: "none" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="pwd-success-section">
                <div className="row">
                  <div className="col-md-12 col-lg-6 offset-lg-3">
                    <div className="loginVerification-wrapper text-center">
                      <div className="loginVerification-wrapperTitle">
                        <svg
                          className="loginVerification-check"
                          width="60"
                          height="61"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30 55.5C43.75 55.5 55 44.25 55 30.5C55 16.75 43.75 5.5 30 5.5C16.25 5.5 5 16.75 5 30.5C5 44.25 16.25 55.5 30 55.5Z"
                            stroke="#3BA429"
                            strokeWidth="3.375"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            d="M19.375 30.4998L26.45 37.5748L40.625 23.4248"
                            stroke="#3BA429"
                            strokeWidth="3.375"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <h1 className="fw-semibold mt-4">Website Setting Updated Successfully!</h1>
                        <p className="fs-14 fw-normal">Your Website Setting Updated successfully.</p>
                        <div className="button-effect loginPwd-updateBtn">
                          <Link
                            onClick={handleNavigation}
                            to={PAGES.MYACCOUNT}
                            className="btn btn-products btn-addcart"
                          >
                            Back to Myaccount
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
